import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faArrowCircleDown} from '@fortawesome/pro-solid-svg-icons';
import {canCreatePdfFromCategory} from '../enablers';
import {CategoryActionLabel} from '../locales';
import {type ICategory} from '../schema';
import {CATEGORY_EVENT} from './constants';

export const categoryActionCreatePDFDownloadIcon = faArrowCircleDown;

/**
 * Create and download pdf from category assets
 * @param params
 * @returns Action
 */
export const categoryActionCreatePDFDownload = (
	category?: ICategory,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'category-create-pdf-download',
	cb: () => dispatcher.trigger(CATEGORY_EVENT.CREATE_PDF_DOWNLOAD, category),
	enableTest: () => canCreatePdfFromCategory(category),
	icon: categoryActionCreatePDFDownloadIcon,
	get label() {
		return CategoryActionLabel.CREATE_PDF_DOWNLOAD;
	},
	...params,
});

export default categoryActionCreatePDFDownload;
